<template>
    <transition name="fade">
        <div v-if="vaModalOpen" class="modal value-add-modal" tabindex="-1">
            <div class="modal-dialog shadow">
                <div class="modal-content p-0">
                    <div class="modal-header p-2 bg-primary text-center justify-content-between d-flex align-items-center">
                        <h3 class="modal-title flex-fill text-start ps-2 text-white">{{ vaName }}</h3>
                        <div @click="closeModal()">
                            <i class="fa-regular fs-4 fa-circle-xmark text-white cursor-pointer me-2" title="Close"></i>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex flex-column mb-2">
                            <input id="reg_plate" name="reg_plate" type="text" disabled class="reg-input fw-bold my-md-2 my-lg-0 w-100" :value="car?.registration" placeholder="Enter Reg" autocomplete="off"/>
                        </div>
                        <VeeForm :validation-schema="this.valueAdd?.code == 'RCAIRCON' || this.valueAdd?.code == 'RCAIRCONYF' ? airConSchema : valueAddSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div">
                            <form @submit="handleSubmit($event, OnPostcodeSubmit)">
                                <Field id="gasUnknown" name="gasUnknown" type="hidden" :value="gasUnknown" />
                                <Field id="selectedItem" name="selectedItem" type="hidden" :value="selectedItem" />
                                <template v-if="car">
                                    <small class="d-block">Vehicle make and model:</small>
                                    <b class="d-block">{{ car?.make + ' ' + car?.model }}</b>
                                </template>
                                <template v-if="valueAdd?.code == 'RCAIRCON' || valueAdd?.code == 'RCAIRCONYF'">
                                    <div v-if="gasUnknown != null && gasUnknown == true" class="alert alert-info small p-2 mt-2">
                                        <p>Our data indicates you need the earlier <b>R134A gas</b>, but since your vehicle was registered between <b>2014</b> and <b>2016</b> (when manufacturers began phasing in the new <b>R1234YF gas</b>), your vehicle could have either type of gas.</p>
                                        <p class="mb-1">Please select the correct type of gas for your vehicle below:</p>
                                        <Popper :content="errors.gas" arrow placement="top" class="w-100 m-0 border-0" :show="errors.gas ? true : false">
                                            <Field v-slot="{ field }" name="gas" type="radio" class="d-flex align-items-center" v-model="selectedItem">
                                                <label class="d-flex align-items-center gap-2 cursor-pointer" title="Select R134A gas">
                                                    <input type="radio" name="gas" v-bind="field" value="RCAIRCON" />
                                                    <b>R134A gas</b>
                                                </label>
                                                <label class="d-flex align-items-center gap-2 cursor-pointer" title="Select R1234YF gas">
                                                    <input type="radio" name="gas" v-bind="field" value="RCAIRCONYF" />
                                                    <b>R1234YF gas</b>
                                                </label>
                                            </Field>
                                        </Popper>
                                        <p class="mt-2 mb-0">Our mechanics will check your vehicle before starting any work, to ensure the chosen gas is correct.</p>
                                    </div>
                                    <div v-else>
                                        <small class="d-block">Aircon regas type required:</small>
                                        <b class="d-block">{{ valueAdd.name }}</b>
                                    </div>
                                </template>
                                <template v-else-if="valueAdd?.code == 'WHEELALIGNMENT' || valueAdd?.code == 'RCWHEELALIGN4'">
                                    <div class="alert alert-info small p-2 mt-2">
                                        <p class="mb-1">Choose your wheel alignment type:</p>
                                        <Popper :content="errors.alignment" arrow placement="top" class="w-100 m-0 border-0" :show="errors.alignment ? true : false">
                                            <Field v-slot="{ field }" name="alignment" type="radio" class="d-flex align-items-center" v-model="selectedItem">
                                                <label class="d-flex align-items-center gap-2 cursor-pointer" title="Select Two Wheel Alignment">
                                                    <input type="radio" name="alignment" v-bind="field" value="WHEELALIGNMENT" />
                                                    <b>Two Wheel Alignment</b>
                                                </label>
                                                <label class="d-flex align-items-center gap-2 cursor-pointer" title="Select Four Wheel Alignment">
                                                    <input type="radio" name="alignment" v-bind="field" value="RCWHEELALIGN4" />
                                                    <b>Four Wheel Alignment</b>
                                                </label>
                                            </Field>
                                        </Popper>
                                    </div>
                                </template>
                                <div v-if="selectedItem != null || gasUnknown == false">
                                    <hr>
                                    <b class="d-block">From &pound;{{ valueAdd?.display_price }}</b>
                                    <small class="d-block">Price is dependant on chosen garage</small>
                                    <hr>
                                </div>
                                <button
                                    type="submit"
                                    class="btn btn-primary btn-sm w-100"
                                >
                                    <span>Continue to choose a garage</span>
                                </button>
                            </form>
                        </VeeForm>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { Form as VeeForm, Field, ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
    import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';

    export default {
        props: ['vaModalOpen', 'imageBasePath', 'vaName', 'valueAdd', 'car', 'vaCode', 'postcode', 'gasUnknown'],
        components: {
        	VeeForm, Field, ErrorMessage
        },
        mounted() {
            console.log('testing');
        },
        data() {
            const airConSchema = yup.object({
                gas: yup.string()
                .when('gasUnknown', {
                    is: true,
                    then: yup.string().required('Please select a gas type to proceed').nullable()
                })
            });

            const valueAddSchema = yup.object({
                alignment: yup.string()
                .when('selectedItem', {
                    is: null,
                    then: yup.string().required('Please select an alignment type to proceed').nullable()
                })
            });

            return {
                selectedItem: null,
                availableGasses: ['RCAIRCON', 'RCAIRCONYF'],
                availableAlignments: ['WHEELALIGNMENT', 'RCWHEELALIGN4'],
                valueAddSchema,
                airConSchema,
                closingModal: false
            }
        },
        methods: {
            closeModal() {
                console.log('hello');
                this.closingModal = true;
                this.selectedItem = null;
                this.$emit('close-modal');
            },
            async toggleSelection(currentSelection, newSelection) {
                this.emitter.emit('isLoading', true);
                var currentSelectedItem = (currentSelection != null ? currentSelection : (this.valueAdd?.code.includes('RCAIRCON') ? 'RCAIRCON' : 'WHEELALIGNMENT'));

                if(this.closingModal == false) {
                    await axios.post('/ajax/update_basket_item/' + currentSelectedItem + '/' + newSelection);
                }
                
                var fitterData = new FormData();
                fitterData.append('postcode', this.postcode);
                fitterData.append('valueAddCode', newSelection);

                //Search for fitter that offers this service within [default range] of customers postcode
                let fitter_response = await axios.post('/ajax/get_fitter_offering_cheapest_service', fitterData);

                this.emitter.emit('isLoading', false);
                this.emitter.emit('updatedFitter', fitter_response.data);

                //get the basket, and emit globally to update basket component
                let response = await axios.post('/ajax/get_basket/' + true);
                this.emitter.emit('updateBasket', response.data.basket);

                //resets the closing modals state on mount
                this.closingModal = false;
            },
            OnPostcodeSubmit() {
                this.emitter.emit('isLoading', true);
				
                var formData = new FormData();
                formData.append('postcode', this.postcode);

                //this will use the selected item, or if its Air Con using default gas, it will just use the valueAdd code.
                formData.append('serviceCode', this.selectedItem != null ? this.selectedItem : this.valueAdd.code);

				axios.post('/modal-submit', formData)
                .then(response => {
                    void navigateWithAttribution(response.data);
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
			onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                console.log(errors);
                firstInvalidField[0].focus();
            }
        },
        watch: {
            selectedItem(newValue, oldValue) {
                this.toggleSelection(oldValue, newValue);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .reg-input {
        width: 100%;
        border: 0;
        padding: 2.5px 5px;
        border-radius: 6px;
        background: #fc3 !important;
        background-color: #fc3 !important;
        text-align: center;
        color: #212121;
        font-size: 20px;
        text-transform: uppercase;
        &::placeholder {
            color: #212121;
            opacity: 1;
        }
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
	}
    .value-add-modal {
        .modal-dialog {
            max-width: 340px;
        }
    }
</style>